import config from '../config'
import axios from 'axios'

const baseUrl = config.apiGateway.URL + config.apiGateway.VERSION

export const callAPI = (url, type, postData, params) => {
    // debugger

     const requestOptions = {
      method: type,
      url: baseUrl + url,
      headers: { 'Content-Type': 'application/json' },
      data: JSON.stringify(postData),
      params: params
    };

    // return fetch(baseUrl + url, requestOptions)
    return axios(requestOptions);
}


export default callAPI;